import { render, staticRenderFns } from "./LogworkStickyWrapper.vue?vue&type=template&id=28385690&scoped=true&"
import script from "./LogworkStickyWrapper.vue?vue&type=script&lang=js&"
export * from "./LogworkStickyWrapper.vue?vue&type=script&lang=js&"
import style0 from "./LogworkStickyWrapper.vue?vue&type=style&index=0&id=28385690&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28385690",
  null
  
)

export default component.exports